"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fiMonster = exports.fiRaw = exports.fAbiRun = exports.fAbi = exports.fi32run = exports.fi32 = void 0;
function fi32(i, y, x, h, w) {
    if (h === void 0) { h = 1; }
    if (w === void 0) { w = 1; }
    return {
        x: x,
        y: y,
        i: i,
        w: w,
        h: h,
    };
}
exports.fi32 = fi32;
function fi32run(idx, y, x, num) {
    var frames = [];
    for (var i = 0; i < num; i++) {
        frames.push(fi32(idx, y, x + i));
    }
    return frames;
}
exports.fi32run = fi32run;
function fAbi(i, y, h, w) {
    if (h === void 0) { h = 1; }
    if (w === void 0) { w = 1; }
    return {
        x: y,
        y: 0,
        i: i,
        w: w,
        h: h,
    };
}
exports.fAbi = fAbi;
function fAbiRun(idx, y, num) {
    var frames = [];
    for (var i = 0; i < num; i++) {
        frames.push(fAbi(idx, y + i));
    }
    return frames;
}
exports.fAbiRun = fAbiRun;
function fiRaw(i, x, y, w, h) {
    return {
        x: x,
        y: y,
        i: i,
        w: w,
        h: h,
    };
}
exports.fiRaw = fiRaw;
function fiMonster(y, x, h, w) {
    if (h === void 0) { h = 1; }
    if (w === void 0) { w = 1; }
    return {
        x: x,
        y: y,
        i: 2,
        w: w,
        h: h,
    };
}
exports.fiMonster = fiMonster;
